import { Trans } from 'react-i18next';

import { Anchor, Body1, Stack } from '@myphx-engineering/phx-design-system';

import externalRoutes from '../../../../external-routes';

export const NewDescription = ({ isSpecialty }: { isSpecialty?: boolean }) => {
    if (isSpecialty) {
        return <Trans i18nKey="priorAuthorization.statusPage.new.specialty" />;
    }

    return (
        <Stack>
            <Body1>
                <Trans
                    i18nKey="priorAuthorization.statusPage.new.nonSpecialty.partOne"
                    components={{
                        1: (
                            <Anchor
                                href={externalRoutes.priorAuthForm}
                                target="_blank"
                            />
                        ),
                    }}
                />
            </Body1>
            <Body1>
                <Trans i18nKey="priorAuthorization.statusPage.new.nonSpecialty.partTwo" />
            </Body1>
        </Stack>
    );
};
